import React from 'react'

export default {
  VMware: React.lazy(() => import('./Internal.VMware')),
  VMwarePrivate: React.lazy(() => import('./Internal.VMware.Private')),
  Minio: React.lazy(() => import("./Internal.Minio")),
  MinioManaged: React.lazy(() => import('./Internal.Minio.Managed')),
  FastChannel: React.lazy(() => import("./Internal.FastChannel")),
  Opennebula: React.lazy(() => import("./Internal.Opennebula")),
  Kubernetes: React.lazy(() => import("./Internal.Opennebula.Kubernetes")),
  InfluxdbReport: React.lazy(() => import("./Internal.Influxdb.Report"))
}